export const MIN_MAP_ZOOM = 1;
export const MAX_MAP_ZOOM = 4;
export const MAP_ZOOM_STEP = 0.25;

export function clampMapZoom(zoom: number): number {
  return Math.min(MAX_MAP_ZOOM, Math.max(MIN_MAP_ZOOM, zoom));
}

export function stepMapZoom(zoom: number, direction: -1 | 1): number {
  return clampMapZoom(zoom + direction * MAP_ZOOM_STEP);
}

export function zoomedScrollOffset(
  scrollOffset: number,
  viewportSize: number,
  currentContentSize: number,
  nextContentSize: number,
): number {
  const focus = scrollOffset + viewportSize / 2;
  const contentFocus =
    currentContentSize > 0 ? focus / currentContentSize : 0.5;
  return Math.max(0, contentFocus * nextContentSize - viewportSize / 2);
}

/** `PointerEvent.button` der mittleren Maustaste — verschiebt die Karte. */
export const MAP_PAN_BUTTON = 1;

/** Nur die primäre Maustaste setzt Punkte; Mittel-/Rechtsklick nie. */
export function isMapPlacementButton(button: number): boolean {
  return button === 0;
}

export function pannedScrollOffset(
  startOffset: number,
  startPointer: number,
  pointer: number,
): number {
  return Math.max(0, startOffset - (pointer - startPointer));
}
